module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recommendationStatus.higherplan":"Some recommendations are not available on your current subscription"}}')
  delete Component.options._Ctor
}
